import { useCallback, useMemo } from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { setModal } from 'ducks/modals/slices';
import { CardInfo, CardInfoParams } from 'ducks/types/common-types';
import { findCurrentBatch, getCardInfoParams } from 'utils/modal/helpers';

// TODO: add batch type
export const useParameterConnectionsActions = (
  card_children: (number | CardInfoParams)[],
  card_info: CardInfo,
  batch: any[],
) => {
  const dispatch = useAppDispatch();

  const handleCreateConnection = useCallback(
    (owner_id: number | null) => {
      dispatch(setModal({ create_parameter: { owner_id }, create_parameter_view: true }));
    },
    [dispatch],
  );

  const length: 0 | CardInfoParams[] = useMemo(
    () => getCardInfoParams(card_children?.length, card_info?.current_params?.length),
    [card_children?.length, card_info?.current_params?.length],
  );

  const currentBatchParams = useMemo(
    () => findCurrentBatch(batch, card_info.batch_definition_item_id),
    [batch, card_info.batch_definition_item_id],
  );

  let isCurrentBatchCardInfo: boolean | undefined;

  if (card_info && card_info.children_item_ids) {
    const currentBatchCardInfo = findCurrentBatch(batch, card_info.children_item_ids[0]);
    isCurrentBatchCardInfo = !!currentBatchCardInfo;
  }

  const { children_params, current_params } = currentBatchParams || {};

  return { length, children_params, current_params, isCurrentBatchCardInfo, handleCreateConnection };
};
